import React from "react";
import "./styles.scss";
import { DashboardBasicAccountApplicationDocument } from "../../../api/commercial/generated-types";

interface SignatureIconProps {
  type: DashboardBasicAccountApplicationDocument["status"];
}

interface InvoicingTypeIconProps {
  hasDecentralizedInvoicing: DashboardBasicAccountApplicationDocument["hasDecentralizedInvoicing"];
}

interface IconProps {
  icon?: string;
  children?: React.ReactNode;
}

export default function BasicIcons({
  icon,
  children,
}: IconProps): React.JSX.Element {
  return (
    <div className="scd-icon-wrapper">
      {icon && <i className={icon} />}
      {children}
    </div>
  );
}

export function SignatureIcon({ type }: SignatureIconProps): React.JSX.Element {
  return (
    <BasicIcons>
      <i className={`scd-signature-${type.toLowerCase()}-icon`} />
    </BasicIcons>
  );
}

export function InvoicingTypeIcon({
  hasDecentralizedInvoicing,
}: InvoicingTypeIconProps): React.JSX.Element {
  const type = hasDecentralizedInvoicing ? "decentralized" : "centralized";
  return (
    <BasicIcons>
      <i className={`scd-${type}-invoicing-icon`} />
    </BasicIcons>
  );
}

export function InsurancePlusIcon(): React.JSX.Element {
  return (
    <BasicIcons>
      <i className={`scd-insurance-plus-icon`} />
    </BasicIcons>
  );
}

export function DocumentIcon(): React.JSX.Element {
  return (
    <BasicIcons>
      <i className="icon-scd-document"></i>
    </BasicIcons>
  );
}
